import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { Reveal, SectionHeading } from "@/components/common/Reveal";

const SPANS = ["md:col-span-7 md:row-span-2", "md:col-span-5", "md:col-span-5"];

export const ServicesBento = () => (
  <section className="bg-[#0A0A0A] py-24 md:py-32" data-testid="home-services">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <SectionHeading eyebrow="What We Do" title={<>Three pillars. <span className="italic gold-text">One strategy.</span></>} />
        <Reveal><Link to="/services" className="btn-outline-gold" data-testid="home-services-all-link">All Services</Link></Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.key} delay={i * 0.1} className={SPANS[i]}>
            <Link to={`/services#${s.key}`} data-testid={`home-service-card-${s.key}`}
              className={`group lux-card lift h-full flex flex-col justify-between gap-10 p-7 md:p-10 ${i === 0 ? "bg-[#3B1152]/60 md:min-h-[420px]" : "md:min-h-[260px]"}`}>
              <div className="flex justify-between items-start">
                <s.icon className="w-10 h-10 text-[#D4AF37]" strokeWidth={1.2} />
                <ArrowUpRight className="w-6 h-6 text-white/40 group-hover:text-[#D4AF37] transition-colors duration-300" />
              </div>
              <div>
                <h3 className={`${i === 0 ? "text-4xl md:text-5xl" : "text-3xl"} font-medium`}>{s.title}</h3>
                <p className="mt-3 md:mt-4 text-white/65 font-light leading-relaxed max-w-md">{s.tagline}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const MissionSplit = () => (
  <section className="relative bg-black py-24 md:py-32 overflow-hidden" data-testid="home-mission">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-16 items-center">
      <Reveal className="md:col-span-6 relative">
        <div className="absolute -inset-4 border border-[#D4AF37]/30 rounded-[2rem] translate-x-6 translate-y-6 hidden md:block" />
        <img src="/images/vault.jpg" srcSet="/images/vault-m.jpg 800w, /images/vault.jpg 1400w" sizes="(max-width: 768px) 100vw, 50vw" loading="lazy" alt="Golden vault door" className="relative rounded-[2rem] w-full h-[300px] md:h-[540px] object-cover" />
      </Reveal>
      <div className="md:col-span-6">
        <SectionHeading eyebrow="Our Mission"
          title={<>Empowering people to build <span className="italic gold-text">generational wealth.</span></>}
          sub="We empower individuals through financial education, strategic tax preparation, business development, and financial solutions — so every client walks away with clarity, confidence and a plan." />
        <Reveal delay={0.2} className="mt-10 border-l-2 border-[#D4AF37] pl-6">
          <p className="font-display text-2xl md:text-3xl italic text-white/90">“Simply Good People Providing Exceptional Service.”</p>
        </Reveal>
        <Reveal delay={0.3} className="mt-10 flex flex-wrap gap-4">
          <Link to="/about" className="btn-gold" data-testid="home-mission-about-link">Meet the Founder</Link>
          <Link to="/get-started" className="btn-glass" data-testid="home-mission-intake-link">Start Intake</Link>
        </Reveal>
      </div>
    </div>
  </section>
);
